import {
  Box,
  Heading,
  HStack,
  Icon,
  List,
  ListIcon,
  ListItem,
  Text,
  useColorModeValue
} from '@chakra-ui/react';
import { Card, CardHeader, CardBody } from '@chakra-ui/card';
import { BiTime } from 'react-icons/bi';
import { GrLocation } from 'react-icons/gr';
import { FaChalkboardTeacher, FaRegMoneyBillAlt, FaRunning } from 'react-icons/fa';
import { GoShield } from 'react-icons/go';
import * as React from 'react';
import { Activity } from '../models/activity';
import CurrencyData from './currency-data';

interface Props {
  activity: Activity;
}

const hasValue = (value: string | null | undefined): boolean =>
  value != null && value.trim().length > 0;

function MemberActivityDetails(props: Props): JSX.Element {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const headerBg = useColorModeValue('green.50', 'green.900');
  const headerBorderColor = useColorModeValue('green.200', 'green.700');
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const secondaryTextColor = useColorModeValue('gray.600', 'gray.300');
  const iconColor = 'green.500';
  const HeaderIcon = props.activity.isInsurance ? GoShield : FaRunning;

  return (
    <Card
      width="100%"
      bg={cardBg}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="lg"
      boxShadow="md"
      overflow="hidden"
    >
      <CardHeader
        bg={headerBg}
        borderBottom="1px solid"
        borderColor={headerBorderColor}
        py={4}
      >
        <HStack spacing={3}>
          <Box
            bg={cardBg}
            p={2}
            borderRadius="md"
            border="1px solid"
            borderColor={headerBorderColor}
          >
            <Icon as={HeaderIcon} color={iconColor} boxSize={5} />
          </Box>
          <Heading size="md" color={textColor}>
            {props.activity.name}
          </Heading>
        </HStack>
      </CardHeader>

      <CardBody py={4}>
        <List spacing={3}>
          {!props.activity.isInsurance && (
            <>
              {hasValue(props.activity.scheduleDetails) && (
                <ListItem>
                  <HStack align="flex-start" spacing={3}>
                    <ListIcon as={BiTime} color={iconColor} mt={1} />
                    <Text color={secondaryTextColor}>
                      <Text as="span" fontWeight="semibold" color={textColor}>
                        Horario:{' '}
                      </Text>
                      {props.activity.scheduleDetails}
                    </Text>
                  </HStack>
                </ListItem>
              )}
              {hasValue(props.activity.location) && (
                <ListItem>
                  <HStack align="flex-start" spacing={3}>
                    <ListIcon as={GrLocation} color={iconColor} mt={1} />
                    <Text color={secondaryTextColor}>
                      <Text as="span" fontWeight="semibold" color={textColor}>
                        Ubicación:{' '}
                      </Text>
                      {props.activity.location}
                    </Text>
                  </HStack>
                </ListItem>
              )}
              {hasValue(props.activity.responsiblePersonsFullNames) && (
                <ListItem>
                  <HStack align="flex-start" spacing={3}>
                    <ListIcon as={FaChalkboardTeacher} color={iconColor} mt={1} />
                    <Text color={secondaryTextColor}>
                      <Text as="span" fontWeight="semibold" color={textColor}>
                        Instructores:{' '}
                      </Text>
                      {props.activity.responsiblePersonsFullNames}
                    </Text>
                  </HStack>
                </ListItem>
              )}
            </>
          )}
          <ListItem>
            <HStack align="flex-start" spacing={3}>
              <ListIcon as={FaRegMoneyBillAlt} color={iconColor} mt={1} />
              <Text color={secondaryTextColor}>
                <Text as="span" fontWeight="semibold" color={textColor}>
                  Valor mensual:{' '}
                </Text>
                <CurrencyData value={props.activity.monthlyPrice} />
              </Text>
            </HStack>
          </ListItem>
        </List>
      </CardBody>
    </Card>
  );
}

export default MemberActivityDetails;
